import React from 'react';
import { Field, FormikContextType, getIn, useFormikContext } from 'formik';
import { Fields } from 'modules/af_cm_ui_kit/components';
import { VARIANTS_TYPES } from 'modules/af_cm_ui_kit/components/TextField/variants.types';
import { FIELDS, FIELDS_QUESTIONS, FormValues } from '../Form/Form.types';
import { Props } from './FutureIncome.types';
import { getIsRetired } from '../Form/Form';

const Future: React.FC<Props> = ({ prefix }) => {
  const { values }: FormikContextType<FormValues> = useFormikContext();

  const getFieldValue = (field: string, fieldPrefix: string = prefix) => getIn(values, fieldPrefix)[field];

  const isRetired = getIsRetired(values, prefix.split('.')[0]);

  return (
    <>
      <Field
        component={Fields.Text}
        title={FIELDS_QUESTIONS.MIN_MONTHLY_TAXABLE_RETIRED_INCOME}
        name={`${prefix}.${FIELDS.MIN_MONTHLY_TAXABLE_RETIRED_INCOME}`}
        variant={VARIANTS_TYPES.CURRENCY}
        disabled={getFieldValue(FIELDS.HAS_TAXABLE_INCOME_CONTINUING) || isRetired}
        extraContent={[
          {
            position: 'bottom',
            variant: 'component',
            content: (
              <Field
                component={Fields.Checkbox}
                variant="inline"
                title={FIELDS_QUESTIONS.INCOME_CONTINUING}
                name={`${prefix}.${FIELDS.HAS_TAXABLE_INCOME_CONTINUING}`}
                disabled
              />
            ),
          },
        ]}
      />

      <Field
        component={Fields.Text}
        title={FIELDS_QUESTIONS.MIN_MONTHLY_TAX_FREE_RETIRED_INCOME}
        name={`${prefix}.${FIELDS.MIN_MONTHLY_TAX_FREE_RETIRED_INCOME}`}
        disabled
        variant={VARIANTS_TYPES.CURRENCY}
        extraContent={[
          {
            position: 'bottom',
            variant: 'component',
            content: (
              <Field
                component={Fields.Checkbox}
                variant="inline"
                title={FIELDS_QUESTIONS.INCOME_CONTINUING}
                name={`${prefix}.${FIELDS.HAS_TAX_FREE_INCOME_CONTINUING}`}
                disabled
              />
            ),
          },
        ]}
      />
    </>
  );
};

export default Future;
